export default __webpack_public_path__ + "static/Image 42-f4fcab9b045de500d693de379c53c818.png";